<template>
	<v-content>
		<v-container fluid>
			<child />
		</v-container>
	</v-content>
</template>

<script>
export default {
	name: 'SimpleLayout'
}
</script>
